
// import { useIntl } from 'react-intl'
// import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import { AsideMenuItem } from './AsideMenuItem'
import { checkIsActive, KTSVG } from '../../../helpers'
import { useLayout } from '../../core'

export function AsideMenuMain(): React.JSX.Element {
  // const intl = useIntl()

  const { config } = useLayout()
  const { aside } = config
  const { currentUser } = useAuth()
  const { isInvitedByOrganization , role} = currentUser?.data?.user
  const { pathname } = useLocation()
  const isHomeActive = checkIsActive(pathname, '/home/board')

  return (
    <>
      <div className='menu-item'>
        <div className={`menu-link without-sub d-flex align-items-center justify-content-between${isHomeActive ? ' active' : ''}`}>
          <Link to='/home/board' className='d-flex align-items-center flex-grow-1 text-decoration-none'>
            <span className='menu-icon'>
              <KTSVG path='/media/icons/duotune/aside-icons/home.svg' className='svg-icon-2' />
            </span>
            <span className='menu-title'>Home</span>
          </Link>
          {aside.minimize && (
            <div
              id='kt_aside_toggle'
              className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle bg-transparent'
              data-kt-toggle='true'
              data-kt-toggle-state='active'
              data-kt-toggle-target='body'
              data-kt-toggle-name='aside-minimize'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr080.svg'
                className='svg-icon-1 rotate-180'
              />
            </div>
          )}
        </div>
      </div>

      {role?.isGuest === true ? (
        <AsideMenuItem to='/board/other-boards' title='Other Boards' icon='/media/icons/duotune/aside-icons/other-board.svg' />
      ) : (
        <>
          <AsideMenuItem to='/board/my-boards' title='My Boards' icon='/media/icons/duotune/aside-icons/my-board.svg' />
          <AsideMenuItem to='/board/other-boards' title='Other Boards' icon='/media/icons/duotune/aside-icons/other-board.svg' />
          {/* <AsideMenuItem to='/board/archived-boards' title='Archived Boards' icon='/media/icons/duotune/aside-icons/archieve-board.svg' /> */}
          <AsideMenuItem
            to='/templates'
            icon='/media/icons/duotune/aside-icons/templates.svg'
            title="Templates"
          />
          <AsideMenuItem
            to='/manage-contacts'
            icon='/media/icons/duotune/communication/com005.svg'
            title="Manage Contacts"
          />
          <AsideMenuItem
            to='/my-reminders'
            icon='/media/icons/duotune/general/gen007.svg'
            title="My Reminders"
          />
          {!isInvitedByOrganization && (
            <AsideMenuItem
              to='/manage-account'
              icon='/media/icons/duotune/aside-icons/template-2.svg'
              title="Manage Account"
            />
          )}
          {!role?.isGuest && (
            <AsideMenuItem
              to='/integrations'
              icon='/media/icons/duotune/social/soc002.svg'
              title="Integrations"
            />
          )}
        </>
      )}

    </>

  )
}
